import React from 'react';
import { KatButton, KatModal } from '@amzn/katal-react';
import { FunctionMetadata } from '../../services/Batcher/BatcherService';

interface FunctionPickerModalProps {
    open: boolean;
    loading: boolean;
    error: string;
    search: string;
    availableFunctions: FunctionMetadata[];
    filteredFunctions: FunctionMetadata[];
    pageFunctions: FunctionMetadata[];
    currentPage: number;
    totalPages: number;
    onSearchChange: (value: string) => void;
    onPagePrev: () => void;
    onPageNext: () => void;
    onAddFunction: (fn: FunctionMetadata) => void;
    onClose: () => void;
}

/** Modal for searching, paginating and adding available functions to the chain. */
const FunctionPickerModal: React.FC<FunctionPickerModalProps> = ({
    open,
    loading,
    error,
    search,
    availableFunctions,
    filteredFunctions,
    pageFunctions,
    currentPage,
    totalPages,
    onSearchChange,
    onPagePrev,
    onPageNext,
    onAddFunction,
    onClose,
}) => {
    if (!open) return null;

    return (
        <KatModal visible={open} title="Add functions to chain" onClose={onClose}>
            <div className="batcher-modal-body">
                <input
                    type="text"
                    className="batcher-search"
                    placeholder="Search functions by name..."
                    value={search}
                    onChange={e => onSearchChange(e.target.value)}
                />

                <div className="batcher-function-list">
                    {loading ? (
                        <div className="batcher-picker-empty">Loading functions…</div>
                    ) : error ? (
                        <div className="batcher-picker-empty batcher-picker-error">{error}</div>
                    ) : filteredFunctions.length === 0 ? (
                        <div className="batcher-picker-empty">
                            {availableFunctions.length === 0 ? 'No functions available' : 'No functions match your search'}
                        </div>
                    ) : (
                        pageFunctions.map(fn => (
                            <button
                                key={fn.functionIdentifier}
                                type="button"
                                className="batcher-function-item"
                                onClick={() => onAddFunction(fn)}
                            >
                                <span className="batcher-function-item-name">{fn.functionName}</span>
                            </button>
                        ))
                    )}
                </div>

                {totalPages > 1 && (
                    <div className="batcher-pagination">
                        <KatButton variant="link" disabled={currentPage === 0} onClick={onPagePrev}>
                            Previous
                        </KatButton>
                        <span className="batcher-pagination-info">
                            Page {currentPage + 1} of {totalPages}
                        </span>
                        <KatButton variant="link" disabled={currentPage >= totalPages - 1} onClick={onPageNext}>
                            Next
                        </KatButton>
                    </div>
                )}
            </div>

            <div slot="footer" className="batcher-modal-footer">
                <KatButton variant="link" onClick={onClose}>Cancel</KatButton>
            </div>
        </KatModal>
    );
};

export default FunctionPickerModal;
